import { SkyText } from "@skypointcloud/skypoint-ui";
import { RUNNER_HEARTBEAT_STALE_MINUTES } from "@shared/types/credentials";
import type { OverviewRunner } from "@shared/types/overview";
import { QuietMessageBar } from "./QuietMessageBar";
import { formatInstant } from "@/lib/time/displayTime";
import { useDisplayTz } from "@/hooks/use-display-tz";

/**
 * "Runner last seen <time>" (owner answer f, 2026-09-28: "very important"). Every runner replica
 * writes a heartbeat once a minute; past ten minutes with none, schedules are not firing and runs
 * are not moving, so the line becomes a warning bar. The Azure Monitor alert on the same
 * heartbeat is what pages; this is what a person on the screen sees.
 */
export function RunnerLastSeen({ runner }: { runner: OverviewRunner }) {
  const zone = useDisplayTz();
  if (runner.stale) {
    return (
      <QuietMessageBar
        intent="warning"
        layout="multiline"
        title="The runner is not answering"
        message={
          runner.lastSeenAt
            ? `Runner last seen ${formatInstant(runner.lastSeenAt, zone, "short", { named: true })}, more than ${RUNNER_HEARTBEAT_STALE_MINUTES} minutes ago. Scheduled imports do not start and running imports do not move until it is back.`
            : "The runner has not reported yet. Scheduled imports do not start until it does."
        }
        testId="overview-runner-stale"
      />
    );
  }
  return (
    <SkyText size={200} color="muted" block testId="overview-runner-last-seen">
      {`Runner last seen ${formatInstant(runner.lastSeenAt, zone, "short", { named: true })}.`}
    </SkyText>
  );
}
